import { render, staticRenderFns } from "./GestionTraitement.vue?vue&type=template&id=42cd81fc"
import script from "./GestionTraitement.vue?vue&type=script&lang=js"
export * from "./GestionTraitement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports